// extracted by mini-css-extract-plugin
export var subMarquee = "index-module--subMarquee--c61e9";
export var swiper = "index-module--swiper--629fe";
export var swiperItem = "index-module--swiperItem--15ac0";
export var title = "index-module--title--d43df";